jQuery(document).ready(function ($) {
  //Scrool header bar
  function fixedHeader() {
    var height = $(window).scrollTop(); //getting the scrolling height of window
    if (height > 70) {
      $(".main-header").addClass("navbar-faded");
    } else {
      $(".main-header").removeClass("navbar-faded");
    }
  }

  fixedHeader();

  if ($(".main-header").length) {
    $(window).on("scroll", function () {
      // this will work when your window scrolled.
      fixedHeader();
    });
  }
  $("#altura, #peso").mask("#.##0,00", { reverse: true });

  /*MENU RESPONSIVO*/

  $(".menu-mobile").click(function (event) {
    event.preventDefault();
    $(".menu-mobile").toggleClass("active");
    var menuresponsivo = $(".main-header__menu");
    if ($(menuresponsivo).is(":hidden ")) {
      menuresponsivo.slideDown(500);
    } else {
      menuresponsivo.slideUp(500);
    }
  });
});
